<p>pin-page-update works!</p>
